var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container w-full flex flex-wrap mx-auto px-2 pt-8 lg:pt-16 md:pt-16 mt-12"},[_c('div',{staticClass:"w-full mt-4 px-2 lg:px-24 md:px-24"},[_c('div',{staticClass:"text-center text-lg text-background-secondary bg-gray-100 p-5",domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }